import { css } from "@emotion/css";
import { space, text, themeTokens } from "@octopusdeploy/design-system-tokens";
import pluralize from "pluralize";
import React, { useState } from "react";
type ExpandingChipListTableCellProps<TId> = {
    singularName: string;
    ids: TId[];
    renderChipList: (ids: TId[]) => React.ReactNode | React.ReactNode[];
};
const expandStyles = css({
    cursor: "pointer",
    color: themeTokens.color.text.link.default,
    marginLeft: space[8],
    font: text.body.bold.xSmall,
    fontWeight: 700,
});
export const ExpandingChipList = <TId,>({ singularName, ids, renderChipList }: ExpandingChipListTableCellProps<TId>) => {
    const [showAll, setShowAll] = useState<boolean>(false);
    if (!ids || ids.length === 0) {
        return <span />;
    }
    if (showAll) {
        return <>{renderChipList(ids)}</>;
    }
    return (<>
            {renderChipList([ids[0]])}
            {ids.length > 1 && (<a className={expandStyles} onClick={() => setShowAll(true)}>
                    +{ids.length - 1} {pluralize(singularName, ids.length - 1)}
                </a>)}
        </>);
};
